module.exports = __webpack_public_path__ + "static/media/michelle.66c97270.png";